import { Box, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import React, { FC, useContext } from "react";

import { ILocalFileEntry } from "../types";
import { ImageUploaderContext } from "./ImageUploaderContainer";
import ImageUploaderPreviewItem from "./ImageUploaderPreviewItem";

const useStyles = makeStyles(() => ({
  itemsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    margin: -4,
    marginBottom: 8,
    padding: "8px 0",

    "&.disabled": {
      pointerEvents: "none",
      opacity: 0.5,
    },

    "&.has-error": {
      border: "3px solid red",
    },
  },
}));

const ImageUploaderPreviewItems: FC<ImageUploaderItemProps> = ({ localFilesEntry }) => {
  const classes = useStyles({});
  const {
    isValidEntriesLength,
    isValidEntriesSizes,
    isValidEntriesType,
    maximumImages,
    maximumImageSize,
    uploadLoading,
  } = useContext(ImageUploaderContext);

  return (
    <>
      <Box className={clsx([classes.itemsContainer], { disabled: uploadLoading })}>
        {localFilesEntry.map((entry, index) => (
          <ImageUploaderPreviewItem entry={entry} key={index} />
        ))}
      </Box>
      <Box mb={1}>
        <Typography color="error" variant="body2">
          {isValidEntriesLength ? undefined : `Maximum ${maximumImages} image to upload per once`}
        </Typography>
        <Typography color="error" variant="body2">
          {!isValidEntriesType
            ? `Only accept images`
            : !isValidEntriesSizes
            ? `Make sure all files are below ${maximumImageSize}MB`
            : undefined}
        </Typography>
      </Box>
    </>
  );
};

interface ImageUploaderItemProps {
  localFilesEntry: ILocalFileEntry[];
}

export default ImageUploaderPreviewItems;
